function saveModularPDF(){
  const pdfButton = $('#hmc360-modular-pdf-button');
  pdfButton.prop("disabled", true);
  pdfButton.hide();
  
  const loadingGif = $('#modular-pdf-loading');
  loadingGif.show();
  
  var product = {};
  product.modular = JSON.parse(pdfButton.attr('data-modular-product'));
  product.handle = "custom-modular-cabinets";
  product.brand = "Howard Miller";
  product.type = 'modular';
  product.source = "hm_modular";
  product.description = 'none';
  product.specs = 'none';
  product.fileName = "custom_" + getCurrentDate() + ".pdf";
  
  console.log('modular product');
  console.dir(product);
  $.post("https://pim.howardmiller.com/shopify/savePDF2.php", {
    product: JSON.stringify(product)
  })
  .done(function(data) {
    console.log(data);
    var pdfLocation = "https://pim.howardmiller.com/shopify/product-pdfs/" + product.fileName;
    console.log(pdfLocation);
    if(data == "PDF Located" || data == "PDF Generated") { 
      window.open(pdfLocation);
      $('#modular-pdf-loading').hide();
    }
    else {
      console.log("Error: " + data);
      $('#modular-pdf-loading').hide();
      $('<div>The PDF was unable to be saved. Please contact customer service.</div>').insertAfter('#modular-pdf-loading');
    }
  });
}

async function generateDetails() {
  if ($('#hmc360-modular-pdf-button').length === 0 && $('#hmc360-modular-sku-list').length === 0) {
    return;
  }
    
  const player = getIntiaroPlayer("hmc360-viewer");

  


  player.getModularConfiguration(
    true,
    async function (selections) {
      console.log(selections);
      var orderedElementsObject = getOrderedElements(selections);
      orderedElementsObject = setElementCabinetLabels(orderedElementsObject);
      var orderedElements = [
        ...orderedElementsObject.orderedTopElements,
        ...orderedElementsObject.orderedBottomElements,
      ];

      displayElementLabels(orderedElements);

      var topSKUs = generateSKUs(orderedElementsObject.orderedTopElements);
      var bottomSKUs = generateSKUs(orderedElementsObject.orderedBottomElements);

      displaySKUList(
        topSKUs,
        bottomSKUs,
        orderedElementsObject.orderedTopElements,
        orderedElementsObject.orderedBottomElements
      );

      setAllSkusWithLabelsInArray(topSKUs, bottomSKUs, orderedElementsObject.orderedTopElements, orderedElementsObject.orderedBottomElements);
      
      var allSKUs = [...topSKUs, ...bottomSKUs];
      
      var ow = getOverallWidth(allSKUs);
      var oh = getOverallHeight(allSKUs);
      var od = 22;
      var overallWeight = await getOverallWeight(allSKUs);

      var configurationId = "";
      await player.saveConfiguration(configId => (configurationId = configId));

      //set pdf button data
      
      let modularProduct = {
        configId: configurationId,
        skuString: allSKUs.join("_"),
        productImage: getThumbImage(),
        finishes: getOptionsString(orderedElements, "hm_0423_finish", finishLookUp),
        doorStyles: getOptionsString(orderedElements, "hm_0423_left_door_options", doorStyleLookUp),
        doorHardwares: getOptionsString(orderedElements, "hm_0423_left_door_hardware_options", doorHardwareLookUp),
        drawerStyles: getDrawerStylesString(orderedElements, "hm_0423_drawer_style"),
        drawerHardwares: getOptionsString(orderedElements, "hm_0423_drawer_hardware", drawerHardwareLookUp),
        topSurfaces: getOptionsString(orderedElements, "hm_0423_optional_top_surfaces", topSurfaceLookUp),
        overallWidth: ow,
        overallHeight: oh,
        overallDepth: od,
        overallWeight: overallWeight,
      };
      $("#hmc360-modular-pdf-button").attr("data-modular-product", JSON.stringify(modularProduct));

      setPrice();
      onProductDetailsUpdate();
    },
    function (error) {
      console.log(error);
    }
  );
}

async function setPrice(){
  const items = getModularItemsFromSelections();

  const total = (await Promise.all(items.map(i =>
    fetch(`/variants/${i.id}.json`)
      .then(r => r.json())
      .then(d => (+(d.product_variant?.price ?? d.variant?.price ?? 0)) * (i.quantity || 1))
  ))).reduce((a, b) => a + b, 0);

  $('#hmc360-modular-price').remove();
  $('#hmc360-modular-add-to-cart-button-container')
  .children()
  .eq(0)
  .after(`<h4 id='hmc360-modular-price'>${formatCurrency(total)}</h4>`);

  onProductDataUpdate(formatCurrency(total));
}


function formatCurrency(amount) {
  return amount.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
}

function generateSKUs(elements) {
  var SKUs = [];

  elements.forEach(element => {
    const variables = element.variables;
    const id = getId(element.element_id, );

    var sku =
      id +
      "-" +
      finishLookUp(variables["hm_0423_finish"]) +
      "-" +
      doorStyleLookUp(variables["hm_0423_left_door_options"]) +
      doorHardwareLookUp(variables["hm_0423_left_door_hardware_options"]) +
      "-" +
      drawerStyleLookUp(variables["hm_0423_drawer_style"], id) +
      drawerHardwareLookUp(variables["hm_0423_drawer_hardware"]) +
      topSurfaceLookUp(variables["hm_0423_optional_top_surfaces"]);

    SKUs.push(sku);
  });

  return SKUs;
}

function displaySKUList(topSKUs, bottomSKUs, topOrderedElements, bottomOrderedElements) {
  var skuListHTML = $("#hmc360-modular-sku-list"); 
  var ul = $("<ul>");

  for (let i = 0; i < topSKUs.length; i++) {
    ul.append($("<li>").text(`${topOrderedElements[i].cabinetLabel}: ${topSKUs[i]}`));
  }
  for (let i = 0; i < bottomSKUs.length; i++) {
    ul.append($("<li>").text(`${bottomOrderedElements[i].cabinetLabel}: ${bottomSKUs[i]}`));
  }

  skuListHTML.empty();
  skuListHTML.append("<h5 style='margin:0; padding:0; font-size:20px; font-weight: bold;'>Sku List</h5>");
  skuListHTML.append("<i style='font-size:12px; margin-top:-6px;'>Ordered from left to right.</i>");
  skuListHTML.append(ul);
}

function setAllSkusWithLabelsInArray(topSKUs, bottomSKUs, topOrderedElements, bottomOrderedElements) {
  const skuStrings = [];

  for (let i = 0; i < topSKUs.length; i++) {
    skuStrings.push(`${topOrderedElements[i].cabinetLabel}: ${topSKUs[i]}`);
  }
  for (let i = 0; i < bottomSKUs.length; i++) {
    skuStrings.push(`${bottomOrderedElements[i].cabinetLabel}: ${bottomSKUs[i]}`);
  }

  window.skuString = skuStrings.join('\n');
}

function addSetAllCheckBox() {}

function setElementCabinetLabels(oeo) {
  for (let i = 0; i < oeo.orderedBottomElements.length; i++) {
    cabinetLabel = createBottomElementLable(oeo.orderedBottomElements.length, i);
    oeo.orderedBottomElements[i].cabinetLabel = `Bottom ${cabinetLabel}`;

    if (
      oeo.orderedBottomElements[i].hasOwnProperty("neighbours") === false ||
      oeo.orderedBottomElements[i].neighbours.hasOwnProperty("top") === false
    ) {
      continue;
    }

    for (let ii = 0; ii < oeo.orderedTopElements.length; ii++) {
      if (oeo.orderedTopElements[ii].neighbours.bottom === oeo.orderedBottomElements[i].elementKey) {
        oeo.orderedTopElements[ii].cabinetLabel = `Top ${cabinetLabel}`;
        break;
      }
    }
  }

  return oeo;
}
function createBottomElementLable(length, i) {
  switch (length) {
    case 0:
      break;

    case 1:
      return `Cabinet`;

    case 2:
      return `${i === 0 ? "Left" : "Right"} Cabinet`;

    case 3:
      return `${i === 0 ? "Left" : i === 1 ? "Middle" : "Right"} Cabinet`;

    case 4:
      return `${i === 0 ? "Outer Left" : i === 1 ? "Inner Left" : i === 2 ? "Inner Right" : "Outer Right"} Cabinet`;

    case 5:
      return `${
        i === 0 ? "Outer Left" : i === 1 ? "Inner Left" : i === 2 ? "Middle" : i === 3 ? "Inner Right" : "Outer Right"
      } Cabinet`;

    default:
      return `Cabinet ${i + 1}`;
  }
}
function displayElementLabels(orderedElements) {
  for (let i = 0; i < orderedElements.length; i++) {
    //set label
    $(`[id=${orderedElements[i].elementKey}] span`).text(orderedElements[i].cabinetLabel);

    //remove uneeded labels
    var choicesGroup = $(`#choices_group_${orderedElements[i].elementKey}`);
    if (choicesGroup.children().length === 0) {
      choicesGroup.prev().remove();
      choicesGroup.next().remove();
      choicesGroup.remove();
    }
  }
}

function getOrderedElements(selections) {
  //get all elements
  console.log(selections);
  var allElements = [];
  for (const elementKey in selections.elements) {
    if (selections.elements.hasOwnProperty(elementKey)) {
      const element = selections.elements[elementKey];
      element.elementKey = elementKey;
      allElements.push(element);
    }
  }

  //seperate tops and bottoms
  var bottomElements = [];
  var topElements = [];
  allElements.forEach(el => {
    if (el.neighbours.hasOwnProperty("bottom")) topElements.push(el);
    else bottomElements.push(el);
  });

  //get first bottom element
  var orderedBottomElements = [];
  for (let i = 0; i < bottomElements.length; i++) {
    const bottomEl = bottomElements[i];
    if (!bottomEl.neighbours.hasOwnProperty("left")) {
      orderedBottomElements.push(bottomEl);
      break;
    }
  }

  //add the rest of the bottom elements in order
  addRightNeighbours(orderedBottomElements[0], bottomElements, orderedBottomElements);

  //get top elements in order
  var orderedTopElements = [];
  for (let i = 0; i < orderedBottomElements.length; i++) {
    bottomElement = orderedBottomElements[i];
    if (bottomElement.neighbours.hasOwnProperty("top")) {
      topElements.forEach(e => {
        if (e.elementKey == bottomElement.neighbours.top) orderedTopElements.push(e);
      });
    }
  }

  //wrap it up baby!
  return { orderedTopElements, orderedBottomElements };
}
function addRightNeighbours(element, elementArray, orderedArray) {
  if (element.neighbours.hasOwnProperty("right")) {
    elementArray.forEach(e => {
      if (e.elementKey == element.neighbours.right) {
        orderedArray.push(e);
        addRightNeighbours(e, elementArray, orderedArray);
      }
    });
  }
}

function getOptionsString(elements, optionKey, optionFunction) {
  allOptions = [];
  for (let i = 0; i < elements.length; i++) {
    if (elements[i].variables.hasOwnProperty(optionKey)) {
      allOptions.push(optionFunction(elements[i].variables[optionKey], false));
    }
  }

  return [...new Set(allOptions)].join(",");
}
function getDrawerStylesString(elements, optionKey) {
  allDrawerStyles = [];
  for (let i = 0; i < elements.length; i++) {
    if (elements[i].variables.hasOwnProperty(optionKey)) {
      allDrawerStyles.push(drawerStyleLookUp(elements[i].variables[optionKey], getId(elements[i].element_id)));
    }
  }

  return [...new Set(allDrawerStyles)].join(",");
}

function getOverallWidth(allSkus) {
  var overallWidth = 0;

  for (let i = 0; i < allSkus.length; i++) {
    if (allSkus[i].slice(1, 2) !== "C") continue;

    if (allSkus[i].slice(0, 4) === "MC28") overallWidth += 28.25;
    else if (allSkus[i].slice(0, 4) === "MC43") overallWidth += 42.5;
    else overallWidth += 71;
  }

  return overallWidth;
}
function getOverallHeight(allSKUs) {
  var hasTop = false;
  var hasBottom = false;

  for (let i = 0; i < allSKUs.length; i++) {
    if (allSKUs[i].slice(1, 2) === "H") hasTop = true;
    else if (allSKUs[i].slice(1, 2) === "C") hasBottom = true;
  }

  return (hasBottom ? 36 : 0) + (hasTop ? 48 : 0);
}
function getOverallDepth(allSKUs) {
  var hasTop = false;
  var hasBottom = false;

  for (let i = 0; i < allSKUs.length; i++) {
    if (allSKUs[i].slice(1, 2) === "H") hasTop = true;
    else if (allSKUs[i].slice(1, 2) === "C") hasBottom = true;
  }

  return hasBottom ? 22.44 : 17;
}
async function getOverallWeight(allSkus) {
  let overallWeight = 0;

  for (let i = 0; i < allSkus.length; i++) {
    var handle = "products/custom-modular-";
    var sku = allSkus[i].slice(0, 5);

    if(sku == "MC71C") continue;

    if (sku === "MH71A") handle += "valance-";
    else if (sku.slice(1, 2) === "H") handle += "hutch-cabinet-";
    else if (sku.slice(2, 3) === "7") handle += "base-";
    else handle += "base-cabinet-";

    try {
      const response = await fetch(`${window.Shopify.routes.root}${handle}${allSkus[i].slice(0, 5)}.json`);
      const product = await response.json();
      overallWeight += product.product.variants[0].weight;
    } catch (error) {
      console.error(`Error fetching product: ${error}`);
    }
  }

  return overallWeight;
}

function getId(value) {
  const idMap = {
    20212: "MC28A",
    20603: "MC28B",
    20604: "MC28C",
    20125: "MC28D",
    20605: "MC28E",
    20606: "MC28F",
    20268: "MC43A",
    20269: "MC71A",
    20607: "MC71B",
    21986: "MC71C",
    20266: "MH28A",
    20124: "MH28B",
    20267: "MH43A",
    20213: "MH71A",
  };

  return idMap[value] || "id not found";
}
function finishLookUp(value, lookUpSku = true) {
  const skuMap = {
    hm_finish_m1: lookUpSku ? "M2" : "Casual Ivory",
    hm_finish_weathered: lookUpSku ? "K1" : "Weathered",
    hm_finish_espresso: lookUpSku ? "ES" : "Espresso",
  };

  return skuMap[value] || "00";
}
function doorStyleLookUp(value, lookUpSku = true) {
  const skuMap = {
    hm_0423_left_door_options_inset_panel_door: lookUpSku ? "1" : "Inset Panel",
    hm_0423_left_door_options_inset_panel_door_with_moulding: lookUpSku ? "2" : "Inset Panel with Moulding",
    hm_0423_left_door_options_glass_panel_door: lookUpSku ? "3" : "Glass Panel",
    hm_0423_left_door_options_plain_glass_door: lookUpSku ? "4" : "Plain Glass Panel",
  };

  return skuMap[value] || "0";
}
function doorHardwareLookUp(value, lookUpSku = true) {
  const skuMap = {
    hm_0423_left_door_hardware_options_nickel_knob: lookUpSku ? "A" : "Nickel Knob",
    hm_0423_left_door_hardware_options_nickel_bar: lookUpSku ? "B" : "Nickel Bar",
    hm_0423_left_door_hardware_options_nickel_elegant_pull: lookUpSku ? "C" : "Nickel Elegant Pull Bar",
    hm_0423_left_door_hardware_options_iron_knob: lookUpSku ? "G" : "Iron Knob",
    hm_0423_left_door_hardware_options_iron_bar: lookUpSku ? "H" : "Iron Bar",
    hm_0423_left_door_hardware_options_iron_elegant_pull: lookUpSku ? "J" : "Iron Elegant Pull Bar",
    hm_0423_left_door_hardware_options_brass_elegant_pull: lookUpSku ? "F" : "Brass Elegant Pull Bar",
  };

  return skuMap[value] || "0";
}
function drawerStyleLookUp(value, id, lookUpSku = true) {
  const drawerStyleMap = {
    hm_0423_drawer_style_inset_panel_drawer_with_moulding_detail: lookUpSku ? "8" : "Inset Panel with Moulding",
    hm_0423_drawer_style_inset_panel_drawer: lookUpSku ? "9" : "Inset Panel",
  };

  if (id == "MC28B" || id == "MC28C" || id == "MC43A" || id == "MC71A")
    value = "hm_0423_drawer_style_inset_panel_drawer";

  return drawerStyleMap[value] || "0";
}
function drawerHardwareLookUp(value, lookUpSku = true) {
  const drawerHardwareMap = {
    hm_0423_drawer_hardware_nickel_knob: lookUpSku ? "A" : "Nickel Knob",
    hm_0423_drawer_hardware_nickel_bar: lookUpSku ? "B" : "Nickel Bar",
    hm_0423_drawer_hardware_nickel_elegant_pull: lookUpSku ? "C" : "Nickel Elegant Pull Bar",
    hm_0423_drawer_hardware_iron_knob: lookUpSku ? "G" : "Iron Knob",
    hm_0423_drawer_hardware_iron_bar: lookUpSku ? "H" : "Iron Bar",
    hm_0423_drawer_hardware_iron_elegant_pull: lookUpSku ? "J" : "Iron Elegant Pull Bar",
    hm_0423_drawer_hardware_brass_elegant_pull: lookUpSku ? "F" : "Brass Elegant Pull Bar",
  };

  return drawerHardwareMap[value] || "0";
}
function topSurfaceLookUp(value, lookUpSku = true) {
  const surfaceSkuMap = {
    hm_0423_none: lookUpSku ? "-VN" : "Veneer",
    hm_finish_tu: lookUpSku ? "-TU" : "Taupe",
    hm_6_finish_wt: lookUpSku ? "-WT" : "White",
  };

  return surfaceSkuMap[value] || "";
}

function getThumbImage() {
  var player = getIntiaroPlayer("hmc360-viewer");
  var thumbImage = player.getFrameUrl(0);
  return thumbImage;
}